// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PaymentsReceived from '../components/PaymentsReceived/PaymentsReceived';
import { actions as PaymentsAction } from '../duck';
import { actions as AlertActions } from '../../alert/duck';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState){
  return {
    isFetchingPaymentsReceived: state.payments.isFetchingPaymentsReceived,
    paymentsReceived: state.payments.paymentsReceived,
    canAsk: state.payments.paymentsReceivedPageCanAsk,
    fetchPaymentsReceivedError: state.payments.fetchPaymentsReceivedError,
  };
}

function mapDispatchToProps(dispatch: Function){
  return bindActionCreators({ ...PaymentsAction, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsReceived);



// WEBPACK FOOTER //
// ./src/modules/payments/containers/PaymentsReceivedContainer.js